import React from 'react';
import QuizBar from './../../Details/components/QuizBar';
import QuizQuestion from './../../Details/components/Quiz/QuizQuestion';
import './ChildrenApplication.css';
import './../../Details/components/DetailsLayout.css';
import QuizNav from '../../../common/QuizNav/QuizNav';
import Breadcrumb from '../../../common/Breadcrumb/Breadcrumb';

const ChildrenApplicationLayout = props => {
  const isFirstQuestion =  props.currentQuestionI == 0;
  const showPrevious = !isFirstQuestion;
  const isContactInfo = props.currentQuestion.type === "QuizContactInformation";
  const goingBackToOptions = props.currentQuestion.type === "QuizTwoOptionsSelect" && props.enableContinueForTwoOptions;
  const showContinue = (!isContactInfo && props.currentQuestion.type !== "QuizStateSelect") ||
                         goingBackToOptions || 
                         (props.currentQuestion.type == "QuizTwoOptionsSelect" && !isFirstQuestion) || 
                         (props.currentQuestion.type == "QuizStateSelect" && props.currentValueFullfilled());

  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://choicemutual.com';
  const breadcrumbItems = [
    { label: 'Home', url: baseUrl },
    { label: 'Life Insurance Tools', url: `${baseUrl}/life-insurance-tools/` },
    { label: 'Child Life Quotes Calculator' }
  ];

  return (
    <section className="childrenApplication">
      <Breadcrumb items={breadcrumbItems} />
      
      <div className='blobWrapper'>
        <div className="mx-0 c-quoting-blob py-6 content">
          <h3 className='title text-center'>Children’s Life Insurance Quotes</h3>
          <QuizBar childrenApplication {...props} />
          {
            props.questions.map((question, i)=> 
              <QuizQuestion 
                key={`quizQuestionKey${i}`}
                {...props}
                question={question}
                questionI={i}
                childrenApplication
              />
           )
          }
          <QuizNav 
            showPrevious={showPrevious} 
            showContinue={showContinue}
            previousQuestion={props.previousQuestion}
            currentValueFullfilled={props.currentValueFullfilled}
            currentQuestionI={props.currentQuestionI}
            nextQuestion={props.nextQuestion}
          />
        </div>
      </div>


    </section>
  );
};

export default ChildrenApplicationLayout;
